import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ChartContainer, ChartTooltip, ChartTooltipContent } from '@/components/ui/chart';
import { Bar, BarChart, CartesianGrid, XAxis, YAxis, Legend } from 'recharts';
import type { CategoryDistribution } from '@/lib/admin/analytics';

interface CategoryPerformanceChartProps {
  data: CategoryDistribution[];
}

const chartConfig = {
  available: {
    label: 'Available',
    color: 'hsl(197, 24%, 44%)', // brand-teal
  },
  reserved: {
    label: 'Reserved',
    color: 'hsl(197, 30%, 55%)', // champagne-light
  },
  sold: {
    label: 'Sold',
    color: 'hsl(213, 29%, 26%)', // brand-navy
  },
};

export function CategoryPerformanceChart({ data }: CategoryPerformanceChartProps) {
  const chartData = data.map((item) => ({
    category: item.category === '1bed' ? '1 Bedroom' : item.category === '2bed' ? '2 Bedroom' : 'Townhouse',
    Available: item.available,
    Reserved: item.reserved,
    Sold: item.sold,
  }));

  return (
    <Card>
      <CardHeader>
        <CardTitle>Category Performance</CardTitle>
        <CardDescription>Availability breakdown by unit category</CardDescription>
      </CardHeader>
      <CardContent>
        <ChartContainer
          config={chartConfig}
          className="h-[300px] w-full"
        >
          <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="category" />
            <YAxis />
            <ChartTooltip content={<ChartTooltipContent />} />
            <Legend />
            <Bar dataKey="Available" fill="var(--color-available)" />
            <Bar dataKey="Reserved" fill="var(--color-reserved)" />
            <Bar dataKey="Sold" fill="var(--color-sold)" />
          </BarChart>
        </ChartContainer>
      </CardContent>
    </Card>
  );
}

